<template>
  <v-container fluid>
    <div>
      <h3 class="headline">{{ $t('Order Summary') }}</h3>

      <div v-if="loading" class="text-xs-center" style="min-height: 400px">
        <v-layout justify-center align-center row style="height: 400px">
          <v-flex>
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </div>
      <template v-else>
        <v-divider class="mt-3 mb-3"></v-divider>

        <v-layout wrap>
          <v-flex xs6 class="form-control">
            <DatepickerCustomDialog
              v-model="shipping_date"
              style="display: inline-block"
              @input="onchangeDate($event)"
            >
              <template v-slot="{ computedDate }">
                <input
                  name="shipping_date"
                  data-vv-as="Shipping Date"
                  :value="computedDate"
                  readonly
                  placeholder="DD/MM/YYYY"
                  style="display: inline-block"
                  type="text"
                />
              </template>
            </DatepickerCustomDialog>
            <v-btn fab small flat style="vertical-align: top" @click="shipping_date = null"
              ><v-icon>delete</v-icon></v-btn
            >
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <div class="text-xs-right">
              <v-btn
                fab
                outline
                color="primary"
                @click="onRefresh"
                v-tooltip.top="$t('Refresh')"
                small
              >
                <em class="fa fa-refresh" />
              </v-btn>
            </div>
          </v-flex>
          <v-btn
            dark
            small
            color="primary"
            v-if="pageStage === 'dataPage'"
            @click="
              Back()
              pageStage = 'dropPage'
            "
            ><em class="fas fa-chevron-left mr-2" /> ย้อนกลับ</v-btn
          >
          <v-flex xs12 sm12 class="mb-2" v-if="pageStage === 'dropPage'">
            <template v-if="filterDroppoint.length !== 0">
              <div v-for="(item, i) in filterDroppoint" :key="i" style="display: grid">
                <v-hover style="cursor: pointer">
                  <div
                    style="
                      padding: 10px;
                      color: #fff;
                      display: block;
                      font-size: 20px;
                      border: 2px solid #ff706b;
                      background: #ff706b;
                      border-radius: 10px;
                      border-bottom-right-radius: 0px;
                    "
                    @click="changeStatus(item)"
                    slot-scope="{ hover }"
                    :class="`mb-2 elevation-${hover ? 12 : 2}`"
                  >
                    <v-layout wrap>
                      <v-flex> {{ item.text }} </v-flex
                      ><v-flex class="text-xs-right"
                        >{{ item.timePeriod }} <em class="fas fa-chevron-right ml-2"
                      /></v-flex>
                    </v-layout>
                  </div>
                </v-hover>
              </div>
            </template>
          </v-flex>
        </v-layout>

        <div v-if="pageStage === 'dataPage'">
          <v-layout wrap>
            <v-flex xs12 sm6 class="form-control px-1">
              <input type="text" :placeholder="$t('Search')" v-model="search" />
            </v-flex>

            <v-flex xs12 sm6 class="text-xs-center text-sm-right">
              <v-pagination
                v-model="pageNumber"
                :length="pageCount"
                @input="onClickPageinate"
                class="mb-2"
              ></v-pagination>
            </v-flex>
          </v-layout>
          <div>
            <template v-if="filterSummary && filterSummary.length > 0">
              <div v-for="(props, i) in filterSummary" :key="i">
                <v-layout
                  row
                  wrap
                  class="mb-3 pa-1 z-border-red"
                  style="border: 3px solid var(--primary-color)"
                >
                  <v-flex xs6 md2 sm1 style="align-self: center">
                    <v-card-text style="font-size: 18px; color: #000">
                      <strong>Order {{ props.id }}</strong>
                    </v-card-text></v-flex
                  >
                  <!-- <v-divider></v-divider> -->
                  <v-flex
                    xs6
                    md2
                    sm3
                    class="text-xs-center"
                    style="align-self: center; margin-left: auto"
                  >
                    <v-btn
                      :loading="loading"
                      @click="viewDetail(props)"
                      color="primary"
                      outline
                      depressed
                      small
                    >
                      ดูรายละเอียด
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 sm4 class="text-xs-left">
                    <div style="color: #000; height: 100%" class="z-border-red pa-3">
                      <template>
                        {{ props.nameaddress }}
                      </template>
                      <div class="text-xs-left">
                        <p class="mb-0 mt-3">ข้อความถึงคนขับ</p>

                        {{ remarkToDriver(props) }}
                      </div>
                      <v-checkbox
                        class="mt-3"
                        color="primary"
                        style="font-size: 12px; color: black; pointer-events: none"
                        label="จัดเก็บเงินปลายทาง"
                        :input-value="
                          props.order_json && JSON.parse(props.order_json).specialRequests
                            ? JSON.parse(props.order_json).specialRequests[0] === 'COD'
                            : ''
                        "
                      ></v-checkbox>
                    </div>
                  </v-flex>
                  <v-flex xs6 sm4 class="text-xs-center">
                    <div style="color: #000; height: 100%" class="z-border-red ml-1">
                      <v-card-text class="pa-1 mt-2">
                        <span v-if="props.lalamove_total_fee" style="color: #000">
                          {{ props.lalamove_total_fee_currency }}
                          {{ totalAndShopFee(props) }}</span
                        >

                        <v-chip
                          small
                          disabled
                          color="blue"
                          class="white--text mt-2"
                          v-if="props.lalamove_order_status"
                          >{{ $t(props.lalamove_order_status) }}</v-chip
                        >
                        <template v-if="viewDetailDriver(props.lalamove_driver_details_json)">
                          <div>
                            <div class="text-xs-center" style="margin: 4px 0px">
                              <v-avatar
                                :size="60"
                                color="grey lighten-4"
                                style="border: 1px solid #eee"
                              >
                                <img
                                  class="circle"
                                  :src="
                                    viewDetailDriver(props.lalamove_driver_details_json).photo ||
                                    '/static/img/assets/livechat/profile.png'
                                  "
                                  alt
                                />
                              </v-avatar>
                            </div>
                            <p style="color: black" class="mb-0">
                              ทะเบียน:
                              {{ viewDetailDriver(props.lalamove_driver_details_json).plateNumber }}
                            </p>
                            <p style="color: black" class="mb-0">
                              ชื่อ:

                              {{ viewDetailDriver(props.lalamove_driver_details_json).name }}
                            </p>
                            <p style="color: black" class="mb-1">
                              เบอร์โทร:

                              {{ viewDetailDriver(props.lalamove_driver_details_json).phone }}
                            </p>
                          </div>
                        </template>
                        <v-btn
                          v-if="
                            props.lalamove_order_status === 'EXPIRED' ||
                            props.lalamove_order_status === 'REJECTED' ||
                            props.lalamove_order_status === 'CANCELED' ||
                            props.lalamove_order_status === null
                          "
                          flat
                          small
                          color="blue"
                          @click="actionCallLalamove(props)"
                          outline
                          :loading="loadinglala"
                        >
                          เรียก Lalamove
                        </v-btn>

                        <v-btn
                          v-if="
                            props.lalamove_order_status === 'ASSIGNING_DRIVER' ||
                            props.lalamove_order_status === 'ON_GOING'
                          "
                          flat
                          small
                          color="red"
                          @click="cancelLalamoveOrder(props)"
                          outline
                          :loading="loadinglala"
                        >
                          ยกเลิกคำสั่ง
                        </v-btn>

                        <v-btn
                          v-if="props.lalamove_share_link_url"
                          flat
                          small
                          color="warning"
                          @click="openShareLink(props.lalamove_share_link_url)"
                          outline
                        >
                          ติดตามสถานะการจัดส่ง
                        </v-btn>
                      </v-card-text>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
              <!-- </v-data-table> -->
              <div class="text-xs-right" style="padding-top: 10px">
                <v-pagination
                  v-model="pageNumber"
                  :length="pageCount"
                  @input="onClickPageinate"
                  class="mb-2"
                ></v-pagination>
              </div>
            </template>
            <template v-else>
              <div class="text-xs-center" style="margin: 35px 0">
                <img
                  src="/static/img/assets/ecommerce/empty_shopping_cart.png"
                  alt
                  style="width: 230px"
                />
                <h3 class="headline">{{ $t('No data') }}</h3>
              </div>
            </template>
          </div>
        </div>
      </template>
      <v-dialog persistent v-model="showSummaryLalamove" max-width="1000">
        <v-card v-if="summaryLalamove">
          <div class="text-xs-right">
            <v-btn flat small fab @click="showSummaryLalamove = false">
              <v-icon> close </v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <div class="mb-3">
              <v-layout>
                <v-flex class="primary--text pt-2"> สินค้า </v-flex>
              </v-layout>
              <div class="pa-2 z-border-red">
                <v-layout v-for="(item, i) in productdetail" :key="i">
                  <v-flex xs3 class="primary--text pt-2 text-xs-center" v-if="item.photourl">
                    <img width="60px" :src="item.photourl" alt="" />
                  </v-flex>
                  <v-flex xs8 style="align-self: center">
                    {{ item.name }}
                    {{ item.option }}
                  </v-flex>
                  <v-flex xs1 style="align-self: center"> x {{ item.quantity }} </v-flex>
                </v-layout>
              </div>
            </div>
            <template v-if="btnType === 'submitLalamove'">
              <div class="mb-3">
                <v-layout>
                  <v-flex class="primary--text pt-2"> จาก </v-flex>
                </v-layout>
                <div class="pa-2 z-border-red">
                  <template>
                    {{ summaryLalamove.remark }}
                  </template>
                </div>
              </div>

              <div class="form-control">ติดต่อผู้ส่ง</div>
            </template>
          </v-card-text>
          <template v-if="btnType === 'submitLalamove'">
            <v-divider />
            <v-card-text>
              <div class="mb-3">
                <v-layout>
                  <v-flex class="primary--text pt-2"> ถึง </v-flex>
                </v-layout>

                <div class="pa-2 z-border-red">
                  <template>
                    {{ summaryLalamove.nameaddress }}
                  </template>
                </div>
              </div>

              <template>
                <div class="form-control">
                  <v-layout wrap>
                    <v-flex xs6 class="px-1">
                      <div>ติดต่อผู้รับ</div>
                      {{
                        order_json.deliveries
                          ? order_json.deliveries[0].toContact.name
                          : summaryLalamove.nameaddress.split(' , ')[0]
                      }}
                    </v-flex>
                    <v-flex xs6 class="px-1">
                      <div>ข้อความถึงคนขับ</div>
                      <span v-if="order_json.remarks">{{
                        typeof order_json.remarks !== 'object'
                          ? order_json.remarks
                          : order_json.remarks.value
                      }}</span>
                      <span v-if="order_json.deliveries">
                        {{
                          typeof order_json.deliveries[0].remarks !== 'object'
                            ? order_json.deliveries[0].remarks
                            : order_json.deliveries[0].remarks.value
                        }}
                      </span>
                    </v-flex>
                  </v-layout>
                </div>
              </template>

              <v-checkbox
                class="mt-1"
                color="primary"
                style="font-size: 14px; color: black; pointer-events: none"
                label="จัดเก็บเงินปลายทาง"
                :input-value="
                  order_json.specialRequests ? order_json.specialRequests[0] === 'COD' : false
                "
              ></v-checkbox>
            </v-card-text>
            <v-divider />
          </template>
          <v-card-text>
            <template v-if="btnType === 'submitLalamove'">
              <div>ค่าจัดส่ง</div>
              <div>
                {{ lalamove.totalFeeCurrency }} {{ lalamove.totalFee }} บวกค่าส่งเพิ่มเติมจากทางร้าน
                {{ lalamove.totalFeeCurrency }}
                {{ lalamove.shop_fee }} รวมเป็น
                {{ lalamove.totalFeeCurrency }}
                {{ parseInt(lalamove.totalFee) + parseInt(lalamove.shop_fee) }}
              </div>
              <span v-if="summaryLalamove.specialRequests">
                {{ summaryLalamove.specialRequests.includes('COD') ? ' ( เก็บเงินปลายทาง )' : '' }}
              </span>
            </template>
            <div class="text-xs-center">
              <v-btn color="grey" outline @click="showSummaryLalamove = false">
                {{ $t('Back') }}
              </v-btn>

              <v-btn
                color="primary"
                depressed
                v-if="btnType === 'submitLalamove'"
                @click="onPlaceOrderLalamove"
              >
                {{ $t('submit') }}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <template v-if="order_json && order_json.stops">
        <select-gmap
          v-if="showToAddress"
          v-model="showToAddress"
          :location="order_json.stops[1].location"
          @changeLocation="changeLocation('to', $event)"
        ></select-gmap>
      </template>
      <v-dialog persistent v-model="toggleDroppoint" max-width="600">
        <v-card>
          <v-layout row wrap>
            <v-flex class="ml-3">
              <h3 class="title">แก้ไขที่อยู่</h3>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn flat small fab @click="toggleDroppoint = false">
                <v-icon> close </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-autocomplete
              outline
              v-model="droppointSelect"
              :items="$store.state.nvbbDroppointLocationOptions"
              small
              filled
              :label="$t('Address')"
            ></v-autocomplete>
            <v-btn
              class="pl-0 ml-0"
              style="width: 100%"
              outline
              color="primary"
              @click="editAddressDroppoint"
            >
              ยืนยันการแก้ไข
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div class="mb-5 mt-5"></div>
  </v-container>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import api from '@/api'
import moment from 'moment'
import ModalHelp from '@/components/elements/ModalHelp'
import Multiselect from 'vue-multiselect'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import axios from 'axios'
import config from '@/config'
import SelectGmap from './SelectGmap'

export default {
  data: function () {
    return {
      pageStage: 'dropPage',
      showFromAddress: false,
      showToAddress: false,
      order_json: null,
      filterDroppoint: [],
      loading: true,
      driverDetail: null,
      // showDriverDetail: false,
      loadinglala: false,
      btnType: '',
      lalamove: {},
      summaryLalamove: null,
      productdetail: null,
      showSummaryLalamove: false,
      shippingFilter: [],
      shippingOptions: [],
      pageNumber: 1,
      size: 10,
      search: '',
      filterStatus: 'all',
      showStartTimeDialog: false,
      showEndTimeDialog: false,
      starttime: '00:00',
      endtime: '23:59',
      selectedDate: {
        start: moment().toDate(),
        end: moment().toDate()
      },
      summary: [],
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      currentFilter: 'today',
      badge: {
        all: 0,
        drop1: 0,
        drop2: 0,
        drop3: 0,
        drop4: 0,
        drop5: 0,
        drop6: 0,
        drop7: 0,
        drop8: 0,
        drop9: 0,
        drop10: 0,
        drop11: 0,
        drop12: 0,
        drop13: 0,
        drop14: 0,
        drop15: 0,
        drop16: 0,
        drop17: 0,
        drop18: 0,
        drop19: 0,
        drop20: 0,
        drop21: 0,
        drop22: 0,
        drop23: 0
      },

      headers: [
        { value: 'id', text: 'รหัสการสั่งซื้อ', sortable: false },
        {
          value: 'detail',
          text: 'รายละเอียด',
          align: 'center',
          class: 'mw-350',
          sortable: false
        },
        {
          value: 'price',
          text: 'ราคา',
          align: 'center',
          sortable: false
        },
        { value: 'action', text: 'คำสั่ง', align: 'center', sortable: false },
        { value: 'driver', text: 'รายละเอียดคนขับ', align: 'center', sortable: false },
        { value: 'status', text: 'สถานะ', sortable: false, align: 'center' }
      ],
      shipping_date: null,
      droppointSelect: null,
      toggleDroppoint: false,
      dataEdit: null,
      quotation: {
        quotationId: '',
        stopIdShop: '',
        stopIdCustomer: ''
      }
    }
  },
  components: {
    datepicker,
    ModalHelp,
    Multiselect,
    DatepickerCustomDialog,
    SelectGmap
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile'
    }),
    pageCount: function () {
      let l = this.badge[this.filterStatus]
      let s = this.size
      return Math.ceil(l / s)
    },
    filterSummary: function () {
      let vm = this
      let orders = []
      let filter = []
      if (vm.search == '') {
        filter = vm.summary
      } else {
        filter = vm.summary.filter(function (el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.remark.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }

      if (vm.shippingFilter && vm.shippingFilter.length > 0) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some((v) => el.shippingtype == v.value)
        })
      }

      if (vm.shipping_date) {
        filter = filter.filter((el) => {
          return (
            moment(el.shippingdate).format('YYYY-MM-DD') ==
            moment(vm.shipping_date).format('YYYY-MM-DD')
          )
        })
      }

      vm.badge = {
        all: 0,
        drop1: 0,
        drop2: 0,
        drop3: 0,
        drop4: 0,
        drop5: 0,
        drop6: 0,
        drop7: 0,
        drop8: 0,
        drop9: 0,
        drop10: 0,
        drop11: 0,
        drop12: 0,
        drop13: 0,
        drop14: 0,
        drop15: 0,
        drop16: 0,
        drop17: 0,
        drop18: 0,
        drop19: 0,
        drop20: 0,
        drop21: 0,
        drop22: 0,
        drop23: 0,
        drop24: 0,
        drop25: 0,
        drop26: 0
      }
      vm.badge.all = filter.length
      orders = filter
        .map((val) => {
          vm.badge[val.status] += 1
          if (val.order_json) {
            try {
              const json = JSON.parse(val.order_json)
              if (json && json.filterName == vm.filterStatus) {
                return val
              } else if (vm.filterStatus == 'all') {
                return val
              }
            } catch (error) {}
          } else {
            return val
          }
        })
        .filter((order) => order)

      orders = orders.sort(function (a, b) {
        return new Date(b.timestamp) - new Date(a.timestamp)
      })
      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return orders.slice(start, end)
    }
  },
  mounted: async function () {
    var vm = this
    this.loading = true
    this.shipping_date = this.$route.query.datefrom
      ? this.$route.query.datefrom
      : moment().format('YYYY-MM-DD')
    this.selectedDate.start = this.$route.query.datefrom
      ? this.$route.query.datefrom
      : moment().toDate()
    this.selectedDate.end = this.$route.query.datefrom
      ? this.$route.query.datefrom
      : moment().toDate()
    this.starttime = '00:00'
    this.endtime = '23:59'
    if (this.$route.query.filterStatus) {
      this.pageStage = 'dataPage'
      this.filterStatus = this.$route.query.filterStatus
    }
    let promiseOrderSummary = this.getOrderSummary()
    this.shippingOptions = [
      {
        value: 'drop',
        name: 'Drop point'
      },
      {
        value: 'hub',
        name: 'Hub'
      },
      {
        value: 'scg',
        name: 'SCG'
      },
      {
        value: 'interexpress',
        name: 'Inter express'
      }
    ]
    await promiseOrderSummary
    this.loading = false
    this.$store.dispatch('loadProducts')
    axios.defaults.headers.common = {
      AUTHORIZATION: this.$store.getters.securityToken
    }
    await this.$store.dispatch('loadPageProfile')

    vm.refreshInterval = setInterval(async function () {
      await vm.getOrderSummary()
    }, 15000)
  },
  beforeDestroy: function () {
    clearInterval(this.refreshInterval)
  },
  filters: {
    formatdate: function (value) {
      return moment(value).format('YYYY/MM/DD h:mm:ss a')
    }
  },
  methods: {
    remarkToDriver(props) {
      if (props.order_json && JSON.parse(props.order_json).deliveries) {
        return JSON.parse(props.order_json).deliveries[0].remarks.value
      } else if (props.order_json && JSON.parse(props.order_json).remarks) {
        return JSON.parse(props.order_json).remarks.value
      }
      return ''
    },
    openShareLink(link) {
      window.open(link, '_blank')
    },
    Back() {
      let query = Object.assign({}, this.$route.query)
      delete query.filterStatus
      this.$router.replace({ query })
      this.pageStage = 'dropPage'
    },
    toggleDroppointClick(item) {
      this.dataEdit = item
      this.order_json = JSON.parse(item.order_json)
      this.toggleDroppoint = true
    },
    editAddressDroppoint() {
      var vm = this
      if (vm.droppointSelect) {
        vm.$store.dispatch('loading')
        var drop = vm.$store.state.nvbbDroppointLocationOptions.find(function (element) {
          return element.value == vm.droppointSelect
        })
        this.order_json.stops[0].location.lat = drop.location[0].lat_long.split(', ')[0]
        this.order_json.stops[0].location.lng = drop.location[0].lat_long.split(', ')[1]
        this.order_json.stops[0].addresses.th_TH.displayString = drop.displayString
        this.order_json.filterName = drop.filterName
        // this.order_json.filterName =
        this.dataEdit.order_json = JSON.stringify(this.order_json)
        this.dataEdit.remark =
          drop.text + ' ' + drop.desc + ' ช่วงเวลาจัดส่งประมาณ ' + drop.timePeriod

        api.editNvbbOrderSummary(this.dataEdit, function (error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
            return
          }
          vm.$store.dispatch('loading')
        })
        this.toggleDroppoint = false
      }
    },
    totalAndShopFee(summaryLalamove) {
      return (
        parseInt(summaryLalamove.lalamove_total_fee) +
        parseInt(JSON.parse(summaryLalamove.order_json).shop_fee)
      )
    },

    editAddress(summaryLalamove) {
      if (summaryLalamove.order_json) {
        this.order_json = JSON.parse(summaryLalamove.order_json)
        // this.summaryLalamove = summaryLalamove
        // this.showToAddress = true
      }
    },
    changeLocation(type, payload) {
      // if (type == 'from') {
      this.order_json.stops[1].location.lat = payload.location.lat.toString()
      this.order_json.stops[1].location.lng = payload.location.lng.toString()
      this.order_json.stops[1].addresses.th_TH.displayString = payload.placesinfolabel
      this.summaryLalamove.nameaddress = payload.placesinfolabel
    },
    viewDetailDriver(driverDetail) {
      return JSON.parse(driverDetail)
    },
    viewDetail(item) {
      this.btnType = 'viewDetail'
      this.showSummaryLalamove = true
      this.summaryLalamove = item
      if (item.productdetail) {
        this.productdetail = JSON.parse(item.productdetail)
      }
      if (this.summaryLalamove.order_json) {
        this.order_json = JSON.parse(this.summaryLalamove.order_json)
      }
    },

    actionCallLalamove(item) {
      let vm = this
      vm.btnType = 'previewLalamove'
      vm.showSummaryLalamove = true
      vm.summaryLalamove = item
      if (item.productdetail) {
        vm.productdetail = JSON.parse(item.productdetail)
      }
      if (vm.summaryLalamove.order_json) {
        vm.order_json = JSON.parse(vm.summaryLalamove.order_json)

        let customerPhone =
          vm.summaryLalamove.nameaddress.split(' , ')[
            vm.summaryLalamove.nameaddress.split(' , ').length - 1
          ]
        if (customerPhone.charAt(0) == '0') {
          customerPhone = customerPhone.slice(1)
          customerPhone = '+66' + customerPhone
        }

        if (vm.order_json && vm.order_json.deliveries) {
          vm.order_json.deliveries[0].toContact.phone = customerPhone
          vm.order_json.deliveries[0].toContact.name =
            vm.summaryLalamove.nameaddress.split(' , ')[0] || ''
          vm.order_json.stops[1].addresses.th_TH.displayString = vm.summaryLalamove.nameaddress
        }
      }
      vm.submitLalamove()
    },

    async submitLalamove() {
      const vm = this
      vm.showSummaryLalamove = false
      vm.btnType = 'submitLalamove'
      // var lalamove_info = null
      vm.loadinglala = true
      if (vm.order_json.data) {
        if (vm.order_json.remarks && typeof vm.order_json.remarks === 'object') {
          vm.order_json.remarks = vm.order_json.remarks.value
        }
      } else {
        if (vm.order_json.deliveries && typeof vm.order_json.deliveries[0].remarks === 'object') {
          vm.order_json.deliveries[0].remarks = vm.order_json.deliveries[0].remarks.value
        }
      }
      try {
        let data = {}
        if (vm.order_json.data) {
          if (vm.order_json.specialRequests && vm.order_json.specialRequests.includes('COD')) {
            vm.order_json.data.specialRequests.push('CASH_ON_DELIVERY')
          }
          data = {
            data: {
              serviceType: 'MOTORCYCLE',
              specialRequests: vm.order_json.data.specialRequests,
              language: 'th_TH',
              stops: vm.order_json.data.stops
            }
          }
        } else {
          data = {
            serviceType: 'MOTORCYCLE', // fix
            stops: vm.order_json.stops,
            requesterContact: vm.order_json.requesterContact,
            deliveries: vm.order_json.deliveries,
            specialRequests: vm.order_json.specialRequests
          }
        }

        let response = null
        if (vm.order_json.data) {
          response = await axios.post(
            config.serverUrl + `lalamove/v3/${vm.selectedBot.pageid}/get-quotation`,
            data
          )
        } else {
          response = await axios.post(
            config.serverUrl + `lalamove/${vm.selectedBot.pageid}/get-quotation`,
            data
          )
        }

        response = response.data
        if (response.success && response.result) {
          vm.lalamove = response.result
          vm.lalamove.shop_fee = vm.order_json.shop_fee
          if (vm.lalamove.data) {
            vm.quotation = {
              quotationId: vm.lalamove.data.quotationId,
              stopIdShop: vm.lalamove.data.stops[0].stopId,
              stopIdCustomer: vm.lalamove.data.stops[1].stopId
            }
          }
          vm.lalamove.totalFee = vm.lalamove.data
            ? vm.lalamove.data.priceBreakdown.total
            : vm.lalamove.totalFee
          vm.showSummaryLalamove = true
        }
        vm.loadinglala = false
      } catch (error) {
        vm.loadinglala = false
        console.error(error)
      }
    },

    async onPlaceOrderLalamove() {
      const vm = this
      vm.loading = true
      vm.showSummaryLalamove = false
      let data = {}
      let nameaddress = vm.summaryLalamove.nameaddress
        ? vm.summaryLalamove.nameaddress.split(' , ')
        : ''
      let customerPhone = ''
      try {
        customerPhone = nameaddress[nameaddress.length - 1]
        if (customerPhone.charAt(0) == '0') {
          customerPhone = customerPhone.slice(1)
          customerPhone = '+66' + customerPhone
        }
      } catch (error) {
        console.error(error)
        customerPhone = ''
      }
      if (vm.lalamove.data) {
        data = {
          data: {
            quotationId: vm.quotation.quotationId,
            sender: {
              stopId: vm.quotation.stopIdShop,
              name: 'คุณสายชล (รถโตโยต้า สีขาว 5950)',
              phone: '+66628844598'
            },
            recipients: [
              {
                stopId: vm.quotation.stopIdCustomer,
                name: vm.summaryLalamove.nameaddress
                  ? vm.summaryLalamove.nameaddress.split(' , ')[0]
                  : '',
                phone: customerPhone,
                remarks:
                  vm.order_json.remarks && typeof vm.order_json.remarks === 'object'
                    ? vm.order_json.remarks.value
                    : vm.order_json.remarks || ''
              }
            ]
          }
        }
      } else {
        data = {
          serviceType: 'MOTORCYCLE', // fix
          stops: vm.order_json.stops,
          requesterContact: vm.order_json.requesterContact,
          deliveries: vm.order_json.deliveries,
          specialRequests: vm.order_json.specialRequests
        }
      }

      let response = null
      if (vm.lalamove.data) {
        response = await axios.post(
          config.serverUrl +
            `lalamove/v3/${vm.selectedBot.pageid}/${vm.summaryLalamove.id}/place-order`,
          data
        )
      } else {
        response = await axios.post(
          config.serverUrl +
            `lalamove/${vm.selectedBot.pageid}/${vm.summaryLalamove.id}/place-order`,
          data
        )
      }
      response = response.data
      if (response.success) {
        let result = await vm.$swal.fire({
          title: vm.$t('Successfully'),
          text: `เลขที่การชำระเงิน: ${response.result.orderRef || response.result.data.orderId}`,
          type: 'success'
        })
        if (result.value) {
          await vm.getOrderSummary()
        }
      }
      vm.loading = false
    },

    onchangeDate(value) {
      var vm = this
      vm.selectedDate.start = value
      vm.selectedDate.end = value
      vm.starttime = '00:00'
      vm.endtime = '23:59'
      vm.onSelectedDate()
    },
    async onRefresh() {
      this.loading = true
      await this.getOrderSummary()
      this.loading = false
    },

    onClickPageinate: function (pageNum) {
      $('.vb-content').animate({
        scrollTop: 0
      })
    },
    changeDate: function (value) {
      var vm = this
      vm.currentFilter = value
      vm.filterStatus = 'all'
      //
      switch (value) {
        case 'today':
          vm.selectedDate.start = moment().toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'last_7_days':
          vm.selectedDate.start = moment().subtract(7, 'd').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'last_15_days':
          vm.selectedDate.start = moment().subtract(15, 'd').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'last_month':
          vm.selectedDate.start = moment().subtract(1, 'months').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'this_month':
          vm.selectedDate.start = moment().startOf('month').toDate()
          vm.selectedDate.end = moment().endOf('month').toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'this_year':
          vm.selectedDate.start = moment().startOf('year').toDate()
          vm.selectedDate.end = moment().endOf('year').toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'last_365_day':
          vm.selectedDate.start = moment().subtract(365, 'days').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'custom_date':
          break

        case 'custom_time':
          vm.onSelectedDate()
          break
      }
    },
    onSelectedDate: async function (value) {
      this.pageNumber = 1
      this.loading = true
      await this.getOrderSummary()
      this.loading = false
    },
    async cancelLalamoveOrder(order) {
      const vm = this
      vm.loading = true
      if (order.lalamove_order_status == 'ON_GOING') {
        let second = moment().diff(moment(order.paiddate), 'second', true)
        if (second >= 300) {
          await vm.$swal.fire({
            title: vm.$t('Error'),
            text: 'ไม่สามารถยกเลิกเนื่องจากเกินจากเวลาที่กำหนด',
            type: 'error'
          })
          vm.loading = false
          return false
        }
      }
      let result = await vm.$swal.fire({
        title: vm.$t('Do you want to cancel this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let response = null
        response = await axios.delete(
          config.serverUrl + `lalamove/${vm.selectedBot.pageid}/${order.id}/cancel-order`
        )
        response = response.data
        if (response.success) {
          await vm.$swal.fire({
            title: vm.$t('Successfully'),
            type: 'success'
          })
          vm.loading = false
          await vm.getOrderSummary()
        } else {
          vm.loading = false
        }
      }
    },
    onSelectedStartDate: async function (value) {
      this.pageNumber = 1
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      this.selectedDate.start = value
      this.loading = true
      await this.getOrderSummary()
      this.loading = false
    },
    onSelectedEndDate: async function (value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      this.selectedDate.end = value
      this.loading = true
      await this.getOrderSummary()
      this.loading = false
    },
    changeStatus: function (value) {
      this.$router.replace({
        name: 'template',
        query: {
          ...this.$route.query,
          filterStatus: value.filterName
        }
      })

      this.pageStage = 'dataPage'
      this.filterStatus = value.filterName
      this.pageNumber = 1
      this.clearSelectAll()
    },
    getOrderSummary: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
          datefrom:
            moment(vm.selectedDate.start).format('YYYY-MM-DD') +
            (vm.starttime != null ? ' ' + vm.starttime : ''),
          dateto:
            moment(vm.selectedDate.end).format('YYYY-MM-DD') +
            (vm.endtime != null ? ' ' + vm.endtime : ''),
          status: 'paid',
          shippingtype: 'drop',
          tab: 'lalamove'
        }
        this.$router.replace({
          name: 'template',
          query: {
            ...this.$route.query,
            datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD')
          }
        })
        api.getNvbbOrderSummary(data, function (error, response) {
          if (error) {
            console.error(error)
            reject()
            return
          }
          if (response.data) {
            vm.filterDroppoint = []
            vm.filterDroppoint = response.nvbb_drop_point_list
            try {
              vm.summary = response.data.map((el) => {
                let json = []
                if (el.jsonvalue) {
                  try {
                    json = JSON.parse(el.jsonvalue)
                  } catch (error) {}
                }
                return {
                  ...el,
                  jsonvalue: json
                }
              })
            } catch (error) {
              vm.summary = []
            }
          }
          vm.clearSelectAll()
          resolve()
        })
      })
    },
    onChangeStatus: function (index) {
      let vm = this
      vm.updateOrder(index, 'save')
    },
    clearSelectAll() {
      this.cbAll = []
      this.checkboxAll = false
    },
    updateOrder: async function (id, payload, callback) {
      let vm = this
      vm.$store.dispatch('loading')
      if (!vm.summary) {
        return false
      }
      let data = vm.summary.find(function (element) {
        return element.id === id
      })

      if (payload == 'send' && data.status == 'canceled') {
        data.sendreason = true
      }
      if (data) {
        api.editNvbbOrderSummary(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
            return
          }
          if (callback) {
            callback()
          }
          vm.$store.dispatch('loading')
        })
      }
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.pageNumber = 1
        this.clearSelectAll()
      }
    }
  }
}
</script>
<style>
.v-input--checkbox .v-label {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/nvbb-lalamove.vue